(function () {
  var ACTIVE_CLASS = "nav-hover";
  var HIDE_DELAY = 500;

  function toArray(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (value instanceof NodeList || value instanceof HTMLCollection) {
      return Array.from(value);
    }
    return [value];
  }

  function animateIn(elements) {
    toArray(elements).forEach(function (element, index) {
      element.style.animation = "fade-in-up 0.15s ease-in-out forwards, fade-in-up-opacity 0.35s ease-in-out forwards";
      element.style.animationDelay = ((index + 1) * 0.05).toFixed(2) + "s";
    });
  }

  function animateOut(elements) {
    toArray(elements).forEach(function (element) {
      element.style.animation = "none";
      element.style.animationDelay = "";
    });
  }

  function initSecondaryNav(nav) {
    if (!nav || nav.dataset.bhSecondaryNavReady === "true") return;

    var parents = Array.from(nav.querySelectorAll(".site-nav--has-dropdown"));

    if (!parents.length) return;

    nav.dataset.bhSecondaryNavReady = "true";

    var siteHeader = nav.closest(".site-header");
    var sectionRoot = nav.closest("[data-wetheme-section-id]") || siteHeader;
    var overlayHeader = document.querySelector("header.overlay-header");
    var subMenus = Array.from(nav.querySelectorAll(".site-nav__dropdown"));
    var subMenuLinks = Array.from(nav.querySelectorAll(".site-nav__dropdown a"));
    var allLinks = Array.from(nav.querySelectorAll("a"));
    var megaMenuDropdowns = Array.from(nav.querySelectorAll(".site-nav__dropdown.mega-menu-dropdown"));
    var hideTimeout = null;
    var resizeTimeout = null;

    function clearHideTimeout() {
      if (!hideTimeout) return;
      window.clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    function hasOpenDropdowns() {
      return Boolean(document.querySelector(".site-nav--has-dropdown." + ACTIVE_CLASS));
    }

    function updateOverlayState() {
      if (!overlayHeader) return;

      if (document.querySelector(".site-nav--has-dropdown.mega-menu." + ACTIVE_CLASS)) {
        overlayHeader.classList.add("force-hover");
      } else {
        overlayHeader.classList.remove("force-hover");
      }
    }

    function setDropdownOffset(parent) {
      var dropdown = parent.querySelector(".site-nav__dropdown.standard-dropdown");
      if (!dropdown) return;

      dropdown.style.left = "";
      dropdown.style.right = "";

      var navPosition = dropdown.getAttribute("data-logo-placement");
      var dropdownRight = window.innerWidth - (dropdown.getBoundingClientRect().left + dropdown.offsetWidth);

      if (dropdownRight < 15) {
        dropdown.style.right = "0";
        dropdown.style.left = "auto";
      }

      dropdown.querySelectorAll(".site-nav__subdropdown").forEach(function (subDropdown) {
        subDropdown.style.left = "";
        subDropdown.style.right = "";

        var subDropdownRight = window.innerWidth - (subDropdown.getBoundingClientRect().left + subDropdown.offsetWidth);

        if (subDropdownRight < 15) {
          if (navPosition === "left" || navPosition === "above") {
            subDropdown.style.left = "auto";
            subDropdown.style.right = "100%";
          } else {
            subDropdown.style.left = "100%";
            subDropdown.style.right = "auto";
          }
        }
      });
    }

    function adjustMegaMenuPosition() {
      megaMenuDropdowns.forEach(function (dropdown) {
        var parent = dropdown.closest(".site-nav--has-dropdown");
        if (!parent) return;

        dropdown.style.left = "-" + parent.getBoundingClientRect().left + "px";
      });

      if (sectionRoot) {
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        sectionRoot.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
      }
    }

    function showDropdown(parent) {
      if (!parent) return;

      clearHideTimeout();
      parent.classList.add(ACTIVE_CLASS);
      animateIn(parent.querySelectorAll(".mega-menu-block .dropdown-submenu"));

      var stickyHeader = document.querySelector(".sticky-header");
      if (stickyHeader) {
        stickyHeader.classList.remove("sticky-header-transformed");
      }

      updateOverlayState();

      window.setTimeout(function () {
        document.body.addEventListener("touchstart", handleBodyTouchStart);
      }, 0);
    }

    function hideDropdown(targets) {
      clearHideTimeout();

      var items = targets ? toArray(targets) : parents;

      items.forEach(function (item) {
        if (!(item instanceof Element)) return;

        item.classList.remove(ACTIVE_CLASS);
        animateOut(item.querySelectorAll(".mega-menu-block .dropdown-submenu"));
        item.querySelectorAll(".site-nav--has-dropdown").forEach(function (child) {
          child.classList.remove(ACTIVE_CLASS);
        });
      });

      updateOverlayState();
      document.body.removeEventListener("touchstart", handleBodyTouchStart);

      if (!hasOpenDropdowns()) {
        var stickyHeader = document.querySelector(".sticky-header");
        if (stickyHeader) {
          stickyHeader.classList.add("sticky-header-transformed");
        }
      }
    }

    function scheduleHideDropdown(targets) {
      clearHideTimeout();
      hideTimeout = window.setTimeout(function () {
        hideDropdown(targets);
      }, HIDE_DELAY);
    }

    function hideSiblings(item) {
      if (!item || !item.parentElement) return;

      var siblings = Array.from(item.parentElement.children).filter(function (sibling) {
        return sibling !== item;
      });

      hideDropdown(siblings);
    }

    function handleBodyTouchStart(event) {
      if (!event.target.closest("#AccessibleNavSecondary .site-nav__link, #AccessibleNavSecondary .dropdown-submenu")) {
        hideDropdown();
      }
    }

    parents.forEach(function (parent) {
      setDropdownOffset(parent);

      parent.addEventListener("mouseenter", function () {
        hideSiblings(parent);
        showDropdown(parent);
      });

      parent.addEventListener("focusin", function () {
        hideSiblings(parent);
        showDropdown(parent);
      });

      if (parent.classList.contains("mega-menu")) {
        parent.addEventListener("mouseleave", function () {
          scheduleHideDropdown(parent);
        });
      } else {
        parent.addEventListener("mouseleave", function () {
          hideDropdown(parent);
        });
      }
    });

    subMenus.forEach(function (menu) {
      var topLevelParent = menu.closest(".site-nav--has-dropdown");

      if (menu.classList.contains("mega-menu-dropdown")) {
        menu.addEventListener("mouseleave", function () {
          scheduleHideDropdown(topLevelParent);
        });
      } else {
        menu.addEventListener("mouseleave", function () {
          hideDropdown(topLevelParent);
        });
      }

      menu.addEventListener("focusout", function (event) {
        if (menu.contains(event.relatedTarget)) return;

        if (menu.classList.contains("mega-menu-dropdown")) {
          scheduleHideDropdown(topLevelParent);
        } else {
          hideDropdown(topLevelParent);
        }
      });

      Array.from(menu.children).forEach(function (child) {
        if (!(child instanceof HTMLElement) || child.tagName !== "LI") return;

        child.addEventListener("mouseenter", function () {
          hideSiblings(child);

          if (child.classList.contains("site-nav--has-dropdown")) {
            showDropdown(child);
          }
        });
      });
    });

    subMenuLinks.forEach(function (link) {
      link.addEventListener("touchstart", function (event) {
        event.stopImmediatePropagation();
      });
    });

    allLinks.forEach(function (link) {
      link.addEventListener("focusin", function () {
        var item = link.closest("li");

        if (!item || !item.parentElement) return;

        var siblings = Array.from(item.parentElement.children).filter(function (sibling) {
          return sibling !== item;
        });

        hideDropdown(siblings);
      });
    });

    if (siteHeader) {
      siteHeader.addEventListener("mouseleave", function () {
        scheduleHideDropdown();
      });

      siteHeader.querySelectorAll("a, button, select").forEach(function (element) {
        element.addEventListener("focusin", function () {
          if (!nav.contains(element)) {
            hideDropdown();
          }
        });
      });
    }

    window.addEventListener("resize", function () {
      if (resizeTimeout) {
        window.clearTimeout(resizeTimeout);
      }

      resizeTimeout = window.setTimeout(function () {
        parents.forEach(setDropdownOffset);
        adjustMegaMenuPosition();
      }, 300);
    });

    adjustMegaMenuPosition();
  }

  function boot() {
    initSecondaryNav(document.getElementById("AccessibleNavSecondary"));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
